'use client';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { BaseLineEmail } from '@/app/components/icons/BaseLineEmail';
import { BaseLinePhone } from '@/app/components/icons/BaseLinePhone';
import { BaseLineProfile } from '@/app/components/icons/BaseLineProfile';
import { Link } from '@/app/components/icons/Link';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/app/components/ui/dialog';
import { SITE } from '@/app/constants';
import { ENTERPRISE_GATHERING_FORM_LINK, ENTERPRISE_SALES_MANAGER } from '../constants';

/** 企业版咨询弹窗，children 作为触发器。 */
export const ConsultDialog = ({ children }: { children: ReactNode }) => {
  const t = useTranslations();
  const manager = ENTERPRISE_SALES_MANAGER[SITE];

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-[480px]">
        <DialogHeader>
          <DialogTitle>{t('payments.enterprise_dialog.title')}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4 border-system-white10 border-t">
          <div className="mt-4 flex flex-col gap-2">
            <div className="flex items-start gap-2">
              <div className="mt-1 flex size-[14px] flex-shrink-0 items-center justify-center rounded-full bg-system-blue02 font-medium text-[10px] text-white">
                1
              </div>
              <div className="font-medium text-base text-white sm:text-sm">
                {t('payments.enterprise_dialog.first_type')}
              </div>
            </div>

            <ul className="flex flex-col gap-1 pl-[18px]">
              <li className="flex items-center gap-[6px]">
                <BaseLineProfile className="text-[#969696] text-base" />
                <span className="text-sm text-system-white80">
                  {t('payments.enterprise_dialog.manager_name')}: {manager.name}
                </span>
              </li>

              <li className="flex items-center gap-[6px]">
                <BaseLineEmail className="text-[#969696] text-base" />
                <span className="text-sm text-system-white80">
                  {t('payments.enterprise_dialog.manager_email')}: {manager.email}
                </span>
              </li>

              <li className="flex items-center gap-[6px]">
                <BaseLinePhone className="text-[#969696] text-base" />
                <span className="text-sm text-system-white80">
                  {t('payments.enterprise_dialog.manager_phone')}: {manager.phone}
                </span>
              </li>
            </ul>
          </div>

          <div className="flex flex-col gap-2">
            <div className="flex items-start gap-2">
              <div className="mt-1 flex size-[14px] flex-shrink-0 items-center justify-center rounded-full bg-system-blue02 font-medium text-[10px] text-white">
                2
              </div>
              <div className="font-medium text-base text-white sm:text-sm">
                {t('payments.enterprise_dialog.second_type')}
              </div>
            </div>

            <ul className="flex flex-col gap-1 pl-[18px]">
              <li className="flex items-center gap-[6px]">
                <a
                  href={ENTERPRISE_GATHERING_FORM_LINK[SITE]}
                  target="_blank"
                  className="flex items-center gap-[6px] text-[#15B8E5] hover:underline"
                >
                  <Link className="rotate-[90deg] text-base" />
                  <span className="text-sm">{t('payments.enterprise_dialog.gathering_form')}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
